import { render, staticRenderFns } from "./LeaderboardPlayerComponent.vue?vue&type=template&id=74e92ce3&scoped=true&"
import script from "./LeaderboardPlayerComponent.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardPlayerComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardPlayerComponent.vue?vue&type=style&index=0&id=74e92ce3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e92ce3",
  null
  
)

export default component.exports